import BlogScreen from "../../screens/Generic/BlogScreen/BlogScreen"
import { getStaticProps } from "../../screens/Generic/BlogScreen/data"

export { getStaticProps }

export default BlogScreen
